export const getDashboardListing = (state) => state.dashboards.dashboardListing;
export const getArchivedDashboards = (state) => state.dashboards.archive;



// WEBPACK FOOTER //
// ./dashboards/selectors.js